import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService, notCloseMessageOptions } from '../../../../core';
import { MotivoPerdaVendaExibicao } from '../motivo-perda-venda-exibicao';

@Component({
    selector: 'sgt-motivo-perda-venda-exibicao-form',
    templateUrl: './motivo-perda-venda-exibicao-form.component.html',
    styleUrls: ['./motivo-perda-venda-exibicao-form.component.less']
})
export class MotivoPerdaVendaExibicaoFormComponent {
    @Input() entity: MotivoPerdaVendaExibicao;
    @ViewChild('form') form: NgForm;

    constructor(private messageService: MessageService) { }

    /** Verifica se o form de exibição dos motivo está válido */
    isValid() {
        if (this.form.invalid) {
            this.messageService.warning('Selecione corretamente todas as opções de exibição deste motivo', 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }
}
